import {Props_ImageGallery} from "./ImageGallery.props";
import {motion} from "framer-motion";

const ImageGallery = (props: Props_ImageGallery) => {
    const {heading,image_one,image_two,image_three,image_four,image_five} = props

    return (
        <section className={`image-gallery`}>
            <div className={`image-gallery__container`}>
                {heading?.content?.value &&
                    <h2 className={`image-gallery__heading`}>
                        {heading.content.value}
                    </h2>
                }
                <div className={`image-gallery__gallery-grid`}>
                    <div className={`image-gallery__inner image-gallery__inner--1`}>
                        {image_one?.src?.value &&
                            <motion.figure
                                className={`image-gallery__gallery-image image-gallery__gallery-image--1`}
                                initial={{opacity: 0, rotateY: 90}}
                                whileInView={{opacity: 1, rotateY: 0}}
                                viewport={{once: true, amount: 0.3}}
                                transition={{duration: 0.7, delay: 0.1}}
                            >
                                <img
                                    src={image_one.src.value as string}
                                    alt={image_one?.alt?.value as string || 'Gallery Image One'}
                                    loading="lazy"
                                    width="400"
                                    height="300"
                                    className={`image-gallery__image image-gallery__image--1`}
                                />
                            </motion.figure>
                        }
                        {image_two?.src?.value &&
                            <motion.figure
                                className={`image-gallery__gallery-image image-gallery__gallery-image--2`}
                                initial={{opacity: 0, rotateY: 90}}
                                whileInView={{opacity: 1, rotateY: 0}}
                                viewport={{once: true, amount: 0.3}}
                                transition={{duration: 0.7, delay: 0.35}}
                            >
                                <img
                                    src={image_two.src.value as string}
                                    alt={image_two?.alt?.value as string || 'Gallery Image One'}
                                    loading="lazy"
                                    width="400"
                                    height="300"
                                    className={`image-gallery__image image-gallery__image--2`}
                                />
                            </motion.figure>
                        }
                        {image_three?.src?.value &&
                            <motion.figure
                                className={`image-gallery__gallery-image image-gallery__gallery-image--3`}
                                initial={{opacity: 0, rotateY: 90}}
                                whileInView={{opacity: 1, rotateY: 0}}
                                viewport={{once: true, amount: 0.3}}
                                transition={{duration: 0.7, delay: 0.6}}
                            >
                                <img
                                    src={image_three.src.value as string}
                                    alt={image_three?.alt?.value as string || 'Gallery Image One'}
                                    loading="lazy"
                                    width="400"
                                    height="300"
                                    className={`image-gallery__image image-gallery__image--3`}
                                />
                            </motion.figure>
                        }
                    </div>
                    <div className={`image-gallery__inner image-gallery__inner--2`}>
                        {image_four?.src?.value &&
                            <motion.figure
                                className={`image-gallery__gallery-image image-gallery__gallery-image--4`}
                                initial={{opacity: 0, rotateY: 90}}
                                whileInView={{opacity: 1, rotateY: 0}}
                                viewport={{once: true, amount: 0.3}}
                                transition={{duration: 0.7, delay: 0.25}}
                            >
                                <img
                                    src={image_four.src.value as string}
                                    alt={image_four?.alt?.value as string || 'Gallery Image One'}
                                    loading="lazy"
                                    width="400"
                                    height="300"
                                    className={`image-gallery__image image-gallery__image--4`}
                                />
                            </motion.figure>
                        }
                        {image_five?.src?.value &&
                            <motion.figure
                                className={`image-gallery__gallery-image image-gallery__gallery-image--5`}
                                initial={{opacity: 0, rotateY: 90}}
                                whileInView={{opacity: 1, rotateY: 0}}
                                viewport={{once: true, amount: 0.3}}
                                transition={{duration: 0.7, delay: 0.5}}
                            >
                                <img
                                    src={image_five.src.value as string}
                                    alt={image_five?.alt?.value as string || 'Gallery Image One'}
                                    loading="lazy"
                                    width="400"
                                    height="300"
                                    className={`image-gallery__image image-gallery__image--5`}
                                />
                            </motion.figure>
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ImageGallery